import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import styles from "./tem_two_image_gallery.module.scss";

export const TemtwoImageGallery = ({ data }) => {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [slider1, setSlider1] = useState(null);
  const [slider2, setSlider2] = useState(null);

  let imgNum;
  if (data?.length <= 5) {
    imgNum = data?.length;
  } else {
    imgNum = 6;
  }

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  });

  const settingsMain = {
    asNavFor: ".slider-nav",
    arrow: true,
    centerMode: true,
    infinite: true,
    centerPadding: "200px 0px",
    slidesToShow: 1,
    speed: 500,
  };

  const settingsThumbs = {
    slidesToShow: imgNum,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    swipeToSlide: true,
  };

  return (
    <section className={styles.section_image_gallery}>
      <div className="uni_overview_gallery_wrapper">
        <div className="uni_overview_gallery_slider">
          {data && data.length > 0 && (
            <Slider
              {...settingsMain}
              asNavFor={nav2}
              ref={(slider) => setSlider1(slider)}
            >
              {data
                .filter((item) => item.src !== null)
                .map((slide, index) => (
                  <img key={index} src={slide.src} alt={slide?.alt} />
                ))}
            </Slider>
          )}
        </div>

        {data && data.length > 0 && (
          <div className="uni_overview_gallery_thumbnails">
            <Slider
              {...settingsThumbs}
              asNavFor={nav1}
              ref={(slider) => setSlider2(slider)}
            >
              {data
                .filter((item) => item.src !== null)
                .map((slide, index) => (
                  <img
                    key={index}
                    className={styles.slick_slide_image2}
                    src={slide?.src}
                    alt={slide?.alt}
                  />
                ))}
            </Slider>
          </div>
        )}
      </div>
    </section>
  );
};

export default TemtwoImageGallery;
